import { useState, type PropsWithChildren } from 'react';

import { useFlags } from '@mint-lib/routing-context';

import {
  ConfirmationModalContext,
  type ModalDataType,
} from '../../../../../../hooks/useSetConfirmationCurrency.js';
import { ConfirmCurrencyModal } from './ConfirmCurrencyModal.jsx';
import { ConfirmCurrencyModalOld } from './ConfirmCurrencyModalOld.jsx';

export const ConfirmCurrencyProvider = ({ children }: PropsWithChildren) => {
  const ff = useFlags('@mint/arm', ['planningV2currencyWithoutConversion']);

  const [modalData, setModalData] = useState<ModalDataType | null>(null);

  if (!modalData)
    return (
      <ConfirmationModalContext.Provider value={setModalData}>
        {children}
      </ConfirmationModalContext.Provider>
    );

  return (
    <ConfirmationModalContext.Provider value={setModalData}>
      {children}
      {ff.planningV2currencyWithoutConversion.enabled ? (
        <ConfirmCurrencyModal
          modalData={modalData}
          onClose={() => setModalData(null)}
        />
      ) : (
        <ConfirmCurrencyModalOld
          modalData={modalData}
          onClose={() => setModalData(null)}
        />
      )}
    </ConfirmationModalContext.Provider>
  );
};
